<div class="rounded-2xl border border-border-secondary p-5 h-full flex flex-col gap-1">
  @for (step of progressSteps(); track step.status; let i = $index) {
    <div class="flex items-center">
      <!-- Step indicator -->
      <div class="h-8 w-8 flex items-center justify-center">
        @if (step.isComplete) {
          <ui-icon icon="griddy-check" class="text-success-600" />
        } @else if (step.isActive) {
          <ui-loading-spinner [size]="16" />
        } @else {
          <ui-icon icon="griddy-circle-dashed" class="text-text-tertiary" />
        }
      </div>

      <!-- Step label -->
      <span
        class="ml-2 text-base transition-colors"
        [class.font-medium]="step.isActive"
        [class.text-text-primary]="step.isActive"
        [class.text-text-secondary]="step.isComplete && !step.isActive"
        [class.text-text-tertiary]="!step.isComplete && !step.isActive">
        {{ step.label }}
      </span>
    </div>
  }
</div>
